/* eslint-disable no-unused-expressions */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

RtlLayout.propTypes = {
  children: PropTypes.node,
};

export default function RtlLayout({ children }) {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language === i18n.languages[0]) {
      i18n.changeLanguage(i18n.languages[0]);
      theme.direction = i18n.dir();
      document.dir = theme.direction;
    } else if (i18n.language === i18n.languages[1]) {
      i18n.changeLanguage(i18n.languages[1]);
      theme.direction = i18n.dir();
      document.dir = theme.direction;
    }
    theme.direction = i18n.dir();
    document.dir = theme.direction;
  }, [theme.direction]);

  const cacheRtl = createCache({
    key: theme.direction === 'rtl' ? 'rtl' : 'css',
    stylisPlugins: theme.direction === 'rtl' ? [rtlPlugin] : [],
  });

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}
